import { Button, ClearableInput, Multiselect, Select } from '@rio-cloud/rio-uikit';
import { useIntl } from 'react-intl';
import { useSupportGroupForm } from '../../hooks/useSupportGroupForm';
import { SUPPORT_GROUP_LEVELS, SupportGroup, SupportGroupFormData, SupportGroupLevel } from '../../models/supportGroup';

interface SupportGroupFormProps {
  group: SupportGroup | null;
  onSave: (data: SupportGroupFormData) => Promise<string | null>;
  onCancel: () => void;
}

const SupportGroupForm = ({ group, onSave, onCancel }: SupportGroupFormProps) => {
  const intl = useIntl();
  const form = useSupportGroupForm(group, onSave);
  const levelOptions = SUPPORT_GROUP_LEVELS.map(level => ({ id: level, label: level }));

  return (
    <form
      onSubmit={event => {
        event.preventDefault();
        form.submit();
      }}
    >
      <div className={`form-group ${form.nameError ? 'has-error' : ''}`}>
        <label>{intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.name' })} *</label>
        <ClearableInput value={form.name} onChange={form.setName} maxLength={100} />
        {form.nameError && <span className="help-block">{form.nameError}</span>}
      </div>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.level' })} *</label>
        <Select
          value={[form.level]}
          options={levelOptions}
          onChange={option => option && form.changeLevel(option.id as SupportGroupLevel)}
        />
      </div>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.users' })}</label>
        <Multiselect
          value={form.userIds}
          options={form.userOptions}
          onChange={ids => form.setUserIds(ids ?? [])}
          placeholder={intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.usersPlaceholder' })}
          useFilter
        />
      </div>
      {form.submitError && <p className="text-color-danger">{form.submitError}</p>}
      <div className="display-flex justify-content-end gap-10 margin-top-20">
        <Button bsStyle={Button.DEFAULT} onClick={onCancel} disabled={form.saving}>
          {intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.cancel' })}
        </Button>
        <Button bsStyle={Button.PRIMARY} type="submit" disabled={form.saving} iconName={form.saving ? 'rioglyph-spinner' : undefined}>
          {intl.formatMessage({ id: 'intl-msg:backoffice.supportGroupForm.save' })}
        </Button>
      </div>
    </form>
  );
};

export default SupportGroupForm;
